import { InputHTMLAttributes, forwardRef } from "react";
import { getCompactInputClasses } from "./inputStyles";

export interface CompactTextInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  /** Show error styling */
  hasError?: boolean;
  /** Additional CSS classes on the input element */
  inputClassName?: string;
}

/**
 * Compact text input that shares the same border, focus, and colour
 * styles as TextInputWithLabel but at a smaller height (~34px vs 56px).
 *
 * Use for inline forms, table cells, modals, and other tight layouts
 * where the full-height input is too large.
 */
export const CompactTextInput = forwardRef<
  HTMLInputElement,
  CompactTextInputProps
>(({ hasError = false, inputClassName = "", className = "", ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={getCompactInputClasses(
        hasError,
        `text-sm ${inputClassName} ${className}`
      )}
      {...props}
    />
  );
});

CompactTextInput.displayName = "CompactTextInput";
